import { ActionReducer } from '@ngrx/store';
import * as application from '../../actions/application-detail.actions';
import { ApplicationMap } from '../../model/modified-applications.model';

/**
 * Reducer that manages original applications.
 *
 * When an user changes enabled flag for a product we store changes apart of original fetched data to be able to show
 * dirty flag - unsaved changes. When user reverts the changes back we hide the dirty flag - unsaved changes.
 *
 * There is an array of application details fetched from server which is modified and a map of application original.
 * These two are compared to calculate if accounts access has been changed.
 *
 * See also src/app/core/helpers/account-group.helper.ts.
 */
export const backupApplicationDetails: ActionReducer<ApplicationMap> = (state: ApplicationMap = {}, action: application.Actions) => {
    switch (action.type) {
        case application.LOAD_SUCCESS:
            return {...state, [action.payload.appId]: action.payload};
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/backup-application-details/backup-application-details.reducer.ts